import { useEffect, useState } from "react";
import AdminLayout from "@/components/AdminLayout";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { RotateCcw } from "lucide-react";
import { formatMoney } from "@/lib/currency";

const STATES = ["requested", "received", "refunded", "restocked"];

export default function AdminReturns() {
  const [returns, setReturns] = useState([]);
  const load = () => api.get("/returns").then((r) => setReturns(r.data));
  useEffect(() => { load(); }, []);

  const advance = async (id, status) => {
    try {
      await api.put(`/returns/${id}`, { status });
      toast.success(`return ${status}.`);
      load();
    } catch { toast.error("update failed."); }
  };

  return (
    <AdminLayout>
      <div data-testid="admin-returns" className="max-w-5xl">
        <span className="editorial-label">commerce · returns</span>
        <h1 className="font-serif text-5xl lowercase text-charcoal mt-3 mb-2">when a piece comes home.</h1>
        <p className="text-espresso max-w-2xl mb-10">requested → received → refunded → restocked. completing the cycle puts the piece back on the shelf.</p>

        {returns.length === 0 ? (
          <div className="border border-taupe/40 p-16 text-center">
            <RotateCcw className="w-8 h-8 text-taupe mx-auto mb-4" />
            <p className="font-serif text-2xl lowercase text-charcoal">no returns to process.</p>
          </div>
        ) : (
          <div className="space-y-5">
            {returns.map((r, i) => {
              const idx = STATES.indexOf(r.status);
              const next = STATES[idx + 1];
              return (
                <div key={r.id} className="bg-linen border border-taupe/50 p-6" data-testid={`return-row-${i}`}>
                  <div className="flex items-start justify-between mb-4">
                    <div>
                      <p className="editorial-label">order · {r.order_number}</p>
                      <h3 className="font-serif text-2xl lowercase text-charcoal mt-1">{r.item_title}</h3>
                      <p className="text-xs text-espresso mt-1">{r.buyer_name} · {r.buyer_email}</p>
                    </div>
                    <span className={`text-[0.65rem] tracking-widest uppercase px-3 py-1 border ${r.status === "restocked" ? "border-olive text-olive" : "border-brass text-brass"}`}>{r.status}</span>
                  </div>
                  <p className="text-sm text-charcoal italic mb-3">&ldquo;{r.reason}&rdquo;</p>
                  <div className="flex justify-between items-center pt-4 border-t border-taupe/40">
                    <p className="editorial-label">refund · {formatMoney(r.refund_amount)}</p>
                    {next && (
                      <button onClick={() => advance(r.id, next)} data-testid={`advance-return-${i}`} className="bg-brass hover:bg-espresso text-ivory px-5 py-2 text-xs tracking-[0.25em] uppercase">
                        mark {next}
                      </button>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </AdminLayout>
  );
}
